import { getEssentialTokenProfile } from './fallback/essentialProfiles'

export { getEssentialTokenProfile, isEssentialTokenAddress, NATIVE_TOKEN_ADDRESS } from './fallback/essentialProfiles'

export function resolveOfflineTokenProfile(
  address: string,
  chainId: Parameters<typeof getEssentialTokenProfile>[1],
) {
  return getEssentialTokenProfile(address, chainId)
}
